import { render, staticRenderFns } from "./DiffractionLimitViz.vue?vue&type=template&id=e5cb53c2&scoped=true"
import script from "./DiffractionLimitViz.vue?vue&type=script&lang=js"
export * from "./DiffractionLimitViz.vue?vue&type=script&lang=js"
import style0 from "./DiffractionLimitViz.vue?vue&type=style&index=0&id=e5cb53c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cb53c2",
  null
  
)

export default component.exports